import { monthMM as month } from "variables/month.jsx";
import { provJSON_jvector } from "variables/province.jsx";
import { getNumPad, getMonthNameThai } from "variables/functions.jsx";

var moment = require('moment');

const getFormatWarrantyMonthGraph = (array_month, selectedYear) => {
    console.log({ array_month })
    let labels = [];
    let data = [];

    let now = new Date();
    let now_year = now.getFullYear();
    let now_month = now.getMonth();

    for (var i = 0; i < array_month.length; i++) {
        let sum = 0;
        (array_month[i].data).map((d) => sum += parseInt(d.count));
        labels.push(array_month[i].month)
        console.log(array_month[i].month, sum)
        data.push(sum)
    }

    let result = {
        labels: labels,
        data: data
    }

    console.log({ result })
    return result;
}

const getFormatAppUsersMonthGraph = (array_month, selectedYear, total_previous) => {
    let labels = [];
    let data = [];

    let total_appuser = parseInt(total_previous);

    let now = new Date();
    let now_year = now.getFullYear();
    let now_month = now.getMonth();

    for (var i = 0; i < array_month.length; i++) {
        total_appuser += parseInt(array_month[i].count);

        labels.push(array_month[i].month)
        data.push(total_appuser)
    }

    for (var i = 0; i < month.length; i++) {
        if (!labels.includes(month[i])) {
            let index_month = getNumPad(month[i]);
            let year = selectedYear;

            if (moment(`${year}-${index_month}-01`, 'YYYY-MM-DD').valueOf() <= moment(`${now_year}-${now_month}-01`).valueOf()) {
                data.splice(i, 0, 0);
            }
        }
    }

    let result = {
        labels: labels,
        data: data
    }

    // console.log(JSON.stringify(result))
    return result;
}

const getFormatAppUsersDailyGraph = (array_daily, month, total_previous) => {
    let labels = [];
    let data = [];

    let total_appuser = parseInt(total_previous);

    for (var i = 0; i < array_daily.length; i++) {
        total_appuser += parseInt(array_daily[i].count);

        if (array_daily[i].month === month) {
            labels.push(toDateMonthThai(array_daily[i].date))
            data.push(total_appuser)
        }
    }

    let result = {
        labels: labels,
        data: data
    }

    return result;
}

const getFormatWarrantyDailyGraph = (array_daily) => {
    if (array_daily.length === 0) {
        return {
            labels: [],
            data: [],
        }
    }
    const x = array_daily[0].daily
    let y = {}
    const m = moment(x, "YYYY-MM-DD")
    const dayInMonths = m.daysInMonth()
    new Array(dayInMonths).fill(0).forEach((_, i) => {
        const date = m.clone().startOf("month").add(i, "day").format("YYYY-MM-DD")
        const thaiDate = toDateMonthThai(date)
        y[thaiDate] = {
            label: thaiDate,
            count: 0,
        }
    })
    for (var i = 0; i < array_daily.length; i++) {
        let sum = 0;
        (array_daily[i].data).map((d) => sum += parseInt(d.count));
        const date = toDateMonthThai(array_daily[i].daily)
        y[date] = {
            label: date,
            count: sum,
        }
    }
    const labels = Object.values(y).map(v => v.label)
    const data = Object.values(y).map(v => v.count)

    let result = {
        labels,
        data,
    }

    return result;
}

const filterStatisticWarrantyMonth = (array_month, region, province) => {
    // console.log("filter_statistic_warranty_month: " + "region: " + region + ", province: " + province);
    // console.log("array_month: " + JSON.stringify(array_month))

    let filter_statisticwarranty_month = array_month.map(item => {
        let array_data = (item.data).filter(data => {
            return getFilter(data, "provincial_id", parseInt(region))
                && getFilter(data, "prov_id", province)
        })

        return {
            month: item.month,
            data: array_data
        }
    })

    // console.log("result filter_statisticwarranty_month: " + JSON.stringify(filter_statisticwarranty_month))
    return filter_statisticwarranty_month;
}

const filterStatisticWarrantyDaily = (array_daily, month, region, province) => {
    // console.log("filter_statistic_warranty_daily: " + ", month: " + month + ", region: " + region + ", province: " + province);
    // console.log("array_daily: " + JSON.stringify(array_daily))

    let filter_month = array_daily.filter(item => {
        return item.month === month
    });

    let filter_statisticwarranty_daily = filter_month.map(item => {
        let array_data = (item.data).filter(data => {
            return getFilter(data, "provincial_id", parseInt(region))
                && getFilter(data, "prov_id", province)
        })

        return {
            daily: item.date,
            data: array_data
        }
    })

    // console.log("filter_statisticwarranty_daily: " + JSON.stringify(filter_statisticwarranty_daily) + ", month: " + month)
    return filter_statisticwarranty_daily;
}

const filterStatisticAppUserDaily = (array_daily, month) => {
    let filter_month = array_daily.filter(item => { return item.month === month });
    return filter_month;
}

const getFilter = (array_item, attribute, filter_value) => {
    if (filter_value !== "0" && filter_value !== 0) {
        return array_item[attribute] === filter_value;
    }
    return true;
}

const getYear = (year) => {
    switch (year) {
        case "today":
            return getCurrentYear();
        default:
            return year;
    }
}

const getCurrentYear = () => {
    let now = new Date();
    let thisYear = now.getFullYear();
    return thisYear;
}

const setOptionMonthSelect = (month) => {

}

const toDateMonthThai = (textdate) => {
    let date = new Date(textdate);
    let date_format = `${date.getDate()} ${getMonthNameThai(date.getMonth() + 1)}`;

    return date_format;
}

const toProvEN_toProvTH = (prov_en) => {
    var result = provJSON_jvector.filter(item => { return item['provname_en'] === prov_en; });
    return result[0].provname_th;
}

const setWarrantyRegionFormat = (array) => {
    let data_region = array.data_region;
    let total_warranty = array.total;
    let report_region = [];
    let index = 0;
    let total_percent_region = 0;

    data_region.map((item, key) => {
        // if(parseInt(item.provincial_id) !== 0) {
        let percent = total_warranty > 0 ? ((parseInt(item.count) * 100) / total_warranty).toFixed(2) : 0;
        total_percent_region += parseFloat(percent);
        // console.log("percent: " + percent)

        report_region.push({
            "region_name": item.provincial,
            "count_request": item.count,
            "percent_request": percent
        })

        index++;
        // }
    })

    let result_return = {
        report_region: report_region,
        total_warranty: total_warranty,
        total_percent_region: total_percent_region
    }

    return result_return;
}

const setWarrantyProvinceFormatMap = (array) => {
    let mapData = {};
    array.map((province_item, key) => {
        var findIndexProvInArr = provJSON_jvector.findIndex(item => { return item['provname_th'] === province_item.province_t; });
        // หาเจอ (-1 คือ หาไม่เจอ)
        if (findIndexProvInArr !== -1) {
            let foundProv = provJSON_jvector[findIndexProvInArr];
            mapData[foundProv.code] = parseInt(province_item.count);
        }
    })

    return mapData;
}

export {
    getFormatWarrantyMonthGraph,
    getFormatWarrantyDailyGraph,
    getFormatAppUsersMonthGraph,
    getFormatAppUsersDailyGraph,
    getYear,
    getCurrentYear,
    toDateMonthThai,
    toProvEN_toProvTH,
    filterStatisticWarrantyMonth,
    filterStatisticWarrantyDaily,
    filterStatisticAppUserDaily,
    setWarrantyRegionFormat,
    setWarrantyProvinceFormatMap
}
